import { LegalPage, LegalH, LegalP } from "../components/LegalPage";

export default function DirittoDiRecesso() {
  return (
    <LegalPage title="Diritto di Recesso" subtitle="Informazioni ai sensi degli artt. 49 e ss. del D.Lgs. 206/2005 (Codice del Consumo)">
      <LegalH>1. Diritto di recesso entro 14 giorni</LegalH>
      <LegalP>
        In qualità di consumatore, hai il diritto di recedere dal contratto di acquisto, senza alcuna penalità e
        senza specificarne il motivo, entro 14 giorni dalla data di conclusione del contratto (data di acquisto).
      </LegalP>
      <LegalH>2. Servizi digitali personalizzati</LegalH>
      <LegalP>
        I pacchetti MP Coaching prevedono l'elaborazione di un programma personalizzato. Ai sensi dell'art. 59,
        lett. c) e o) del Codice del Consumo, il diritto di recesso è escluso per i beni confezionati su misura o
        chiaramente personalizzati e, per i contenuti digitali, se l'esecuzione è iniziata con il tuo accordo espresso
        e con l'accettazione della perdita del diritto di recesso. Se non hai ancora richiesto l'avvio
        dell'elaborazione del tuo programma, il recesso entro 14 giorni resta pienamente esercitabile.
      </LegalP>
      <LegalH>3. Come esercitare il recesso</LegalH>
      <LegalP>
        Per esercitare il recesso invia una comunicazione esplicita a mpcoaching.online@gmail.com indicando nome, email
        utilizzata per l'acquisto, pacchetto acquistato e data dell'ordine. Riceverai conferma via email.
      </LegalP>
      <LegalH>4. Rimborso</LegalH>
      <LegalP>
        In caso di recesso valido, il rimborso dell'importo pagato viene effettuato tramite lo stesso metodo di
        pagamento utilizzato (Stripe) entro 14 giorni dalla ricezione della comunicazione di recesso.
      </LegalP>
      <LegalH>5. Domande</LegalH>
      <LegalP>
        Per qualsiasi chiarimento prima o dopo l'acquisto puoi scriverci dalla pagina Contatti: ti risponderemo
        personalmente nel più breve tempo possibile.
      </LegalP>
    </LegalPage>
  );
}
